
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.869 4.008L10.91 3.6H7.92v2.88h.58c.23-.49.752-.86 1.36-.86.606 0 1.129.37 1.358.86h.568A.21.21 0 0012 6.263V4.217a.223.223 0 00-.131-.21zM9.918 1.824a.678.678 0 00-.615-.384H7.92v1.68h2.64l-.642-1.296zM6.78 0H.656C.286 0 0 .311 0 .689V4.32h7.44V.689.686A.673.673 0 006.78 0z","fill":"#000"}}),_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"8","y":"6","width":"3","height":"3"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.889 6.25h1.909v1.91h-1.91V6.25z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.843 6.25a.955.955 0 10.955.955.955.955 0 00-.955-.954z","fill":"#000"}})])])
          )
        }
      }
    